import Head from "next/head";
import React from "react";

const CommonMeta = function () {
  return (
    <template>
      <link rel="SHORTCUT ICON" href="/favicon.ico" />
    </template>
  );
};

// 首页
const SeoHome = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="twitter:card" content="app" />
      <meta name="twitter:site" content="@dingtone" />
      <meta name="twitter:app:country" content="US" />
      <meta name="twitter:app:name:iphone" content="Dingtone" />
      <meta name="twitter:app:id:iphone" content="588937297" />
      <meta
        name="twitter:app:url:iphone"
        content="https://apps.apple.com/us/app/dingtone-wifi-calling-text/id588937297"
      />
      <meta name="twitter:app:name:ipad" content="Dingtone" />
      <meta name="twitter:app:id:ipad" content="588937297" />
      <meta
        name="twitter:app:url:ipad"
        content="https://apps.apple.com/us/app/dingtone-wifi-calling-text/id588937297"
      />
      <meta name="twitter:app:name:googleplay" content="Dingtone" />
      <meta name="twitter:app:id:googleplay" content="me.dingtone.app.im" />
      <meta
        name="twitter:app:url:googleplay"
        content="https://play.google.com/store/apps/details?id=me.dingtone.app.im&hl"
      />
      <title>Unlimited Free Calling;Texting App with Second Phone Number</title>
      <meta
        name="description"
        content="Unlimited free calling &amp; texting via WiFi or cellular data without using cell minutes. Call forwarding, voicemail, auto reply and spam call blocking features included. Get yourself a 2nd phone number from Dingtone!"
      />
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// Contact
const SeoContact = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="Contact Us " />
      <title>Contact Us - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// phone-number
const SeoNumber = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta
        name="description"
        content="Get yourself a 2nd number from Dingtone. Add multiple lines to your phone without extra SIM Cards. Enjoy unlimited Free Calling &amp; Texting. Stay safe and anonymous when you give out your number."
      />
      <title>
        Get a Second Phone Number for Unlimited Calling Texting - Dingtone
      </title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// free-calls-and-free-texts
const SeoFree = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        name="description"
        content="Dingtone, a free calling &amp; texting app, allows you to make unlimited free phone calls and send free text messages to anyone. No cell minutes needed!"
      />
      <title>Free Calling &amp; Free Texting App - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// rates-plans
const SeoRates = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        name="description"
        content="Cheap International Calling Rates &amp; Plans, Use Dingtone credits to make low-cost international calls even free calls to anywhere in the world."
      />
      <title>Cheap International Calling Rates &amp; Plans - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// dingtone-free-download
const SeoDownload = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        name="description"
        content="Free download Dingtone&#x27;s free texting &amp; calling app for IOS &amp; Android. Get a second phone number. Enjoy unlimited free calls &amp; texts to anyone!"
      />
      <title>Dingtone Free Download - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// Support
const SeoSupport = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        name="description"
        content="Support Dingtone Support Center – Free Phone Calls, Texts &amp; 	Walkie Talkie, PTT"
      />
      <title>
        Dingtone Support Center – Free Phone Calls, Texts &amp; Walkie Talkie,
        PTT - Dingtone
      </title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// Ourusers
const SeoOurusers = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="" />
      <title>User Story - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// privacy
const SeoPrivacy = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="privacy policy Dingtone" />
      <title>privacy policy - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// Site Map
const SeoSiteMap = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="Site Map Dingtone" />
      <title>Site Map - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// Terms
const SeoTerms = function () {
  return (
    <Head>
      <meta name="renderer" content="webkit" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="Terms of Service Dingtone" />
      <title>Terms of Service - Dingtone</title>
      <CommonMeta></CommonMeta>
    </Head>
  );
};

// 模板模板模板模板 - accelerator
const Default = function () {
  return (
    <Head>
      <title>模板模板模板模板</title>
      <meta name="description" content="模板模板模板模板" />
      <CommonMeta></CommonMeta>
    </Head>
  );
};

export {
  SeoHome,
  SeoContact,
  SeoNumber,
  SeoFree,
  SeoRates,
  SeoDownload,
  SeoSupport,
  SeoOurusers,
  SeoPrivacy,
  SeoSiteMap,
  SeoTerms,
};
